// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"272":"AxisTable","642":"TTOPGeneration","712":"CSVCompare","808":"OfferManagement","864":"SKUManagement"}[chunkId] || chunkId) + "." + {"272":"ef19b511","642":"376ea80c","712":"0f2f084a","808":"8331b01f","864":"8aa7178f","896":"6a8dd8ed"}[chunkId] + ".js";
};